import {
  EntityWithDocumentFullResponse,
  PersonIndividualDetails,
} from '@/modules/entity/types/EntityItemResponse.ts';
import {
  renderEntityContactDetails,
  renderEntityDetailsSection,
  renderEntityDocuments,
  renderEntityTaxResidence,
} from '@/modules/entity/utils/entity-info/entity-info.tsx';

export const RenderIndividualEntityDetails = ({
  individual_entity_details,
  document_files,
  ...entity_details
}: Partial<EntityWithDocumentFullResponse>) => {
  const {
    title,
    first_name,
    middle_name,
    last_name,
    date_of_birth,
    country,
    gender,
    state,
    suburb,
    postcode,
    is_us_person,
    non_us_person_certification,
    tax_residence,
    jointly,
    locality,
    province,
    national_id,
    complete_name,
    complete_name_chinese,
    address_line_1,
    bank_card_number,
    crs_status,
    is_managed_by_another_institution,
    sponsoring_entity_name,
    account_holders_gin,
  } = individual_entity_details || {};

  const {
    bank_name,
    bank_account_bsb,
    bank_account_swift,
    bank_account_iban,
    bank_account_routing_number,
    bank_account_number,
    bank_account_name,
  } = entity_details || {};
  const jointlyDetails = jointly as Partial<PersonIndividualDetails> | undefined;

  return (
    <>
      {renderEntityContactDetails(entity_details)}
      {renderEntityDetailsSection({
        name: 'Individual details',
        items: [
          { label: 'Gender', value: gender },
          { label: 'Title', value: title },
          { label: 'First Name', value: first_name },
          { label: 'Middle Name', value: middle_name },
          { label: 'Last name', value: last_name },
          { label: 'Date of birth', value: date_of_birth },
          { label: 'Country', value: country },
          { label: 'State', value: state },
          { label: 'Suburb', value: suburb },
          { label: 'Locality', value: locality },
          { label: 'Province', value: province },
          { label: 'Postcode', value: postcode },
          { label: 'National ID', value: national_id },
          { label: 'Full name (Pinyin)', value: complete_name },
          { label: 'Full name (Chinese)', value: complete_name_chinese },
          { label: 'Address line 1', value: address_line_1 },
          { label: 'Bank card number', value: bank_card_number },
        ],
      })}
      {jointlyDetails &&
        renderEntityDetailsSection({
          name: 'Individual / Jointly details',
          items: [
            { label: 'Gender', value: jointlyDetails.gender },
            { label: 'Title', value: jointlyDetails.title },
            { label: 'First Name', value: jointlyDetails.first_name },
            { label: 'Middle Name', value: jointlyDetails.middle_name },
            { label: 'Last name', value: jointlyDetails.last_name },
            { label: 'Date of birth', value: jointlyDetails.date_of_birth },
            { label: 'Country', value: jointlyDetails.country },
            { label: 'State', value: jointlyDetails.state },
            { label: 'Suburb', value: jointlyDetails.suburb },
            { label: 'Locality', value: jointlyDetails.locality },
            { label: 'Province', value: jointlyDetails.province },
            { label: 'Postcode', value: jointlyDetails.postcode },
            { label: 'National ID', value: jointlyDetails.national_id },
            { label: 'Full name (Pinyin)', value: jointlyDetails.complete_name },
            { label: 'Full name (Chinese)', value: jointlyDetails.complete_name_chinese },
            { label: 'Address line 1', value: jointlyDetails.address_line_1 },
            { label: 'Bank card number', value: jointlyDetails.bank_card_number },
          ],
        })}
      {renderEntityTaxResidence(tax_residence)}
      {renderEntityDetailsSection({
        items: [
          { label: 'GIIN', value: account_holders_gin },
          { label: 'Sponsoring entity name', value: sponsoring_entity_name },
          {
            label:
              'Is the Account Holder a specified U.S. person? A U.S. person includes a U.S. citizen or resident alien of the U.S. even if residing outside the U.S.',
            value: is_us_person,
          },
          { label: 'Non U.S Person Certification', value: non_us_person_certification },

          {
            label: 'Is the entity an Investment Entity managed by another Financial Institution?',
            value: is_managed_by_another_institution,
          },
          { label: 'CRS status', value: crs_status },
        ],
      })}
      {renderEntityDetailsSection({
        name: 'Payment instructions',
        items: [
          { label: 'Bank name', value: bank_name },
          { label: 'BSB', value: bank_account_bsb },
          { label: 'SWIFT/BIC', value: bank_account_swift },
          { label: 'IBAN', value: bank_account_iban },
          { label: 'Routing number', value: bank_account_routing_number },
          { label: 'Account number', value: bank_account_number },
          { label: 'Account name', value: bank_account_name },
        ],
      })}
      {renderEntityDocuments(document_files || [])}
    </>
  );
};
